import { useSessionNavigationBlocking } from "@/hooks/useSessionNavigationBlocking";
import { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { NoMatchPage } from "../pages/NoMatchPage";

import { z } from "zod";

interface MyRouterContext {
  queryClient: QueryClient;
}

const rootQueryParamsSchema = z.object({
  source: z.string().optional(),
});

export const Route = createRootRouteWithContext<MyRouterContext>()({
  validateSearch: rootQueryParamsSchema,
  component: function RootComponent() {
    // Block navigation when there's an active session
    useSessionNavigationBlocking();

    return (
      <>
        <Outlet />
        {process.env.NODE_ENV === "development" && <TanStackRouterDevtools />}
      </>
    );
  },
  notFoundComponent: () => <NoMatchPage />,
});
